// RxJS
import { of } from 'rxjs';
import { catchError, finalize, tap, debounceTime, delay, distinctUntilChanged } from 'rxjs/operators';
// NGRX
import { Store, select } from '@ngrx/store';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
// State
import { AppState } from '../../../core/reducers';
import { selectProfilesInStore, selectProfilesPageLoading, selectProfilesShowInitWaitingMessage } from '../_selectors/profile.selectors';


export class ProfilesDataSource extends BaseDataSource {
	constructor(private store: Store<AppState>) {
		super();

		this.loading$ = this.store.pipe(
			select(selectProfilesPageLoading)
		);

		this.isPreloadTextViewed$ = this.store.pipe(
			select(selectProfilesShowInitWaitingMessage)
		);

		this.store.pipe(
			select(selectProfilesInStore)
		).subscribe((response: QueryResultsModel) => {
			this.paginatorTotalSubject.next(response.totalCount);
			this.entitySubject.next(response.items);
		});
	}
}
